import React from 'react';
import { BookMarkedIcon, Globe2Icon, LandmarkIcon, SearchIcon, ScrollTextIcon } from 'lucide-react';
export function SocialProof() {
  const items = [['Basado en investigaciones arqueológicas', LandmarkIcon], ['Narrativa documental', ScrollTextIcon], ['Acceso inmediato', Globe2Icon], ['Información documentada', SearchIcon], ['Lectura envolvente', BookMarkedIcon]];
  return <section className="border-y border-dark-border bg-dark-card/60 px-5 py-7" data-id="element-197">
      <div className="mx-auto grid max-w-7xl gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-198">
        {items.map(([label, Icon]) => <div key={label as string} className="flex items-center gap-3 text-sm text-stone-light" data-id="element-199">
            <Icon className="h-5 w-5 shrink-0 text-gold-light" data-id="element-200" />
            <span data-id="element-201">{label}</span>
          </div>)}
      </div>
    </section>;
}